import React from "react";
import { Route, Routes } from "react-router-dom";
import {
	About,
	CareerPlan,
	Contact,
	Education,
	Experience,
	Footer,
	Hero,
	Navbar,
} from "./components";
import ScrollToTop from "./ScrollToTop";
import { LanguageProvider } from "./context/LanguageContext";
import { ThemeProvider } from "./context/ThemeContext";
import {
	TechnicalSupportProject,
	PicoCTFProject,
	Stock4meProject,
	CybersecurityConferenceProject,
	OdooVisitProject,
	EthicalHackingCourseProject,
	SushiShopProject,
	AXAHackathonProject,
	SparExperienceProject,
} from "./pages";

function App() {
	return (
		<ThemeProvider>
			<LanguageProvider>
				<ScrollToTop />
				<div className="min-h-screen flex flex-col bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
					<Navbar />
					<Routes>
						{/* Main Portfolio Page */}
						<Route
							path="/"
							element={
								<main className="flex-grow">
									<Hero />
									<About />
									{/* <Projects /> */}
									<CareerPlan />
									<Experience />
									<Education />
									<Contact />
								</main>
							}
						/>

						{/* Individual Project Pages */}
						<Route
							path="/projects/technical-support"
							element={<TechnicalSupportProject />}
						/>
						<Route
							path="/projects/picoctf-2023"
							element={<PicoCTFProject />}
						/>
						<Route
							path="/projects/stock4me"
							element={<Stock4meProject />}
						/>
						<Route
							path="/projects/cybersecurity-conference"
							element={<CybersecurityConferenceProject />}
						/>
						<Route
							path="/projects/odoo-visit"
							element={<OdooVisitProject />}
						/>
						<Route
							path="/projects/ethical-hacking-course"
							element={<EthicalHackingCourseProject />}
						/>
						<Route
							path="/projects/sushi-shop"
							element={<SushiShopProject />}
						/>
						<Route
							path="/projects/axa-hackathon"
							element={<AXAHackathonProject />}
						/>
						<Route
							path="/projects/spar-experience"
							element={<SparExperienceProject />}
						/>
					</Routes>
					<Footer />
				</div>
			</LanguageProvider>
		</ThemeProvider>
	);
}

export default App;
